import React, { useRef, useState } from 'react';
import RenderThumnailModal from './RenderThumnailModal';
import { getVisibleImages } from './helper';
import { CarouselGridItem } from './CarouselGridItem';

function CarouselGridLayout(props) {
  const { cardFrame, containerTracks, viewAllItemsConfig } = props;
  const videoRef = useRef(null);
  const [showThumbnailLayout, setShowThumbnailLayout] = useState({
    isVisible: false,
    currIndex: 0,
  });

  const imagesData = getVisibleImages(cardFrame?.imagesData);
  const numItemsToShow = containerTracks.numColumns * containerTracks.numRows;
  const imagesList = imagesData?.slice(
    0,
    viewAllItemsConfig?.areAllItemsVisible ? imagesData?.length : numItemsToShow
  );

  function handleImageClick(index) {
    setShowThumbnailLayout((prev) => {
      return {
        currIndex: index,
        isVisible: !prev.isVisible,
      };
    });
  }

  return (
    <>
      {imagesList?.map((data, index) => {
        return (
          <CarouselGridItem
            key={data?.imageUrl}
            handleImageClick={handleImageClick}
            {...props}
            data={data}
            index={index}
            videoRef={videoRef}
          />
        );
      })}
      {showThumbnailLayout.isVisible && (
        <RenderThumnailModal
          cardFrame={cardFrame}
          config={showThumbnailLayout}
          setConfig={setShowThumbnailLayout}
        />
      )}
    </>
  );
}

export default CarouselGridLayout;
